<div [ngClass]="{ 'preview-file-out': messageSource, 'preview-file-in': !messageSource }">
  @if (messageSource) {
    <app-read-receipt class="read-receipt" [messageStatus]="content['messageStatus']"></app-read-receipt>
  }
  <div class="file-details-container">
    <div class="no-preview-block">
      <img
        class="fileImage"
        [src]="noPreviewImg.src"
        [alt]="content['description']"
        width="32"
        />
        @if (noPreviewImg.type) {
          <p class="no-preview-format">
            {{ noPreviewImg.type }}
          </p>
        }
      </div>
      <span class="fileName">{{ fileName }}</span>
      <span class="fileName_type">.{{ fileType }}</span>
      <div class="fileSize">{{ fileSize }}</div>
      <button class="preview-download-button" (click)="onClickDownloadFile()"></button>
    </div>
  </div>
